import React, { useState, useEffect } from "react";
import {
  setActivePage,
  setActiveChildPage,
} from "../../../redux/actions/active-page";
import CompanyShowcase from "./company-showcase";
import CompanyNavigation from "./company-navigation";
import CancelSubscriptionModal from "./modals/cancel-subscription-modal";
import AddMemberModal from "./modals/add-member-modal";
import DeleteSpaceModal from "./modals/delete-space-modal";
import RemoveMemberModal from "./modals/remove-member-modal";
import ChangeRoleModal from "./modals/change-role-modal";
import RemovePaymentMethodModal from "./modals/remove-payment-method-modal";
import AddPaymentMethodModal from "./modals/add-payment-method-modal";
import UpdatePaymentMethodModal from "./modals/update-payment-method-modal";
import ChangeMainSubscriptionModal from "./modals/change-main-subscription-modal";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import {
  changeCompanyModal,
  resetChangeMember,
  resetCompanyDetails,
  resetCompanyReceipts,
  resetCompanySubscription,
  resetCompanyTeam,
  resetDeleteCompany,
  resetDeleteCompanyImage,
  resetDeleteSubscription,
  resetDeleteMember,
  resetSendInvitation,
  resetUpdateCompanyImage,
  retrieveCompanyDetails,
  retrieveCompanyImage,
  retrieveCompanyPaymentMethods,
  retrieveCompanyReceipts,
  retrieveCompanySubscription,
  retrieveCompanyTeam,
  resetUpdateLicenseQuantity,
  resetCompanyChannels,
  retrieveCompanyChannels,
} from "../../../redux/actions/company";
import {
  sendErrorNotification,
  sendSuccessNotification,
} from "../../universal/notifications/notifications";
import { setFallbackMessage } from "../../../redux/actions/universal";

import "./style.scss";

const DashboardCompanyContent = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const modal = useSelector((state) => state.company.showModals);

  const uploadImageError = useSelector(
    (state) => state.company.updateThumbnail.error
  );
  const uploadImageStatus = useSelector(
    (state) => state.company.updateThumbnail.status
  );

  const deleteImageError = useSelector(
    (state) => state.company.deleteThumbnail.error
  );
  const deleteImageStatus = useSelector(
    (state) => state.company.deleteThumbnail.status
  );

  const sendInvitationError = useSelector(
    (state) => state.company.sendInvitation.error
  );
  const sendInvitationStatus = useSelector(
    (state) => state.company.sendInvitation.status
  );

  const removeMemberError = useSelector(
    (state) => state.company.deleteMember.error
  );
  const removeMemberStatus = useSelector(
    (state) => state.company.deleteMember.status
  );

  const changeMemberError = useSelector(
    (state) => state.company.changeMemberError
  );
  const changeMemberStatus = useSelector(
    (state) => state.company.changeMemberStatus
  );

  const deleteSubscriptionError = useSelector(
    (state) => state.company.deleteSubscription.error
  );
  const deleteSubscriptionStatus = useSelector(
    (state) => state.company.deleteSubscription.status
  );

  const deleteCompanyError = useSelector(
    (state) => state.company.deleteCompany.error
  );
  const deleteCompanyStatus = useSelector(
    (state) => state.company.deleteCompany.status
  );

  const updateLicenseQuantityError = useSelector(
    (state) => state.company.updateLicenseQuantity.error
  );
  const updateLicenseQuantityStatus = useSelector(
    (state) => state.company.updateLicenseQuantity.status
  );

  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const companyLoading = useSelector(
    (state) => state.activeCompany && state.activeCompany.loading
  );

  const user = useSelector(
    (state) => state.user && state.user.details && state.user.details.id
  );
  const userLoading = useSelector(
    (state) => state.user && state.user.fetchUserDetails.loading
  );

  const [activeDisplay, setActiveDisplay] = useState("team");

  useEffect(() => {
    const selectedTab = history.location.hash;

    switch (selectedTab) {
      case "#team":
        setActiveDisplay("team");
        break;
      case "#kanaler":
        setActiveDisplay("channels");
        break;
      case "#fakturaer":
        setActiveDisplay("invoices");
        break;
      case "#abonnementer":
        setActiveDisplay("subscriptions");
        break;
      case "#betalingsmetoder":
        setActiveDisplay("paymentmethods");
        break;
      case "#innstillinger":
        setActiveDisplay("settings");
      default:
        break;
    }
  }, [history]);

  useEffect(() => {
    dispatch(resetCompanyDetails());
    dispatch(resetCompanyTeam());
    dispatch(resetCompanyReceipts());
    dispatch(resetCompanySubscription());
    dispatch(resetCompanyChannels());

    dispatch(resetUpdateCompanyImage());
    dispatch(resetDeleteCompanyImage());
    dispatch(resetSendInvitation());
    dispatch(resetDeleteMember());
    dispatch(resetChangeMember());
  }, []);

  useEffect(() => {
    dispatch(setActivePage("company"));
    dispatch(setActiveChildPage(null));
  });

  useEffect(() => {
    if (selectedCompany) {
      dispatch(retrieveCompanyDetails({ companyId: selectedCompany }));
      dispatch(retrieveCompanyTeam({ companyId: selectedCompany }));
      dispatch(retrieveCompanyReceipts({ companyId: selectedCompany }));
      dispatch(retrieveCompanySubscription({ companyId: selectedCompany }));
      dispatch(retrieveCompanyPaymentMethods({ companyId: selectedCompany }));
      dispatch(retrieveCompanyChannels({ companyId: selectedCompany }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCompany]);

  useEffect(() => {
    if (user && !selectedCompany && !userLoading && !companyLoading) {
      history.push("/dashboard/oversikt");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, selectedCompany, companyLoading]);

  useEffect(() => {
    if (uploadImageStatus) {
      sendSuccessNotification("Bildet ble oppdatert.");
      dispatch(retrieveCompanyImage({ companyId: selectedCompany }));
      dispatch(resetUpdateCompanyImage());
    }
    if (uploadImageError) {
      sendErrorNotification("Kunne ikke oppdatere bilde.");
      dispatch(resetUpdateCompanyImage());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadImageStatus, uploadImageError]);

  useEffect(() => {
    if (deleteImageStatus) {
      sendSuccessNotification("Bildet ble slettet.");
      dispatch(retrieveCompanyImage({ companyId: selectedCompany }));
      dispatch(resetDeleteCompanyImage());
    }
    if (deleteImageError) {
      sendErrorNotification("Kunne ikke slette bilde.");
      dispatch(resetDeleteCompanyImage());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteImageStatus, deleteImageError]);

  useEffect(() => {
    if (sendInvitationError) {
      sendErrorNotification(sendInvitationError);
      dispatch(resetSendInvitation());
    }
    if (sendInvitationStatus) {
      sendSuccessNotification("Invitasjon ble sendt.");
      dispatch(resetSendInvitation());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendInvitationStatus, sendInvitationError]);

  useEffect(() => {
    if (removeMemberError) {
      sendErrorNotification("Kunne ikke slette bruker.");
      dispatch(resetDeleteMember());
    }
    if (removeMemberStatus) {
      dispatch(resetDeleteMember());
      sendSuccessNotification("Brukeren ble fjernet.");
      dispatch(retrieveCompanyTeam({ companyId: selectedCompany }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeMemberStatus, removeMemberError]);

  useEffect(() => {
    if (changeMemberError) {
      dispatch(resetChangeMember());
      sendErrorNotification("Kunne ikke oppdatere bruker.");
    }
    if (changeMemberStatus) {
      dispatch(resetChangeMember());
      sendSuccessNotification("Brukeren ble oppdatert.");
      dispatch(retrieveCompanyTeam({ companyId: selectedCompany }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeMemberStatus, changeMemberError]);

  useEffect(() => {
    if (deleteSubscriptionStatus && deleteSubscriptionStatus === "success") {
      dispatch(resetDeleteSubscription());
      dispatch(changeCompanyModal({ cancelSubscription: false }));
      sendSuccessNotification("Abonnementet ditt ble avsluttet.");
      dispatch(retrieveCompanySubscription({ companyId: selectedCompany }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteSubscriptionStatus]);

  useEffect(() => {
    if (deleteSubscriptionError) {
      dispatch(changeCompanyModal({ cancelSubscription: false }));
      sendErrorNotification(deleteSubscriptionError);
      dispatch(resetDeleteSubscription());
    }
  }, [deleteSubscriptionError]);

  useEffect(() => {
    if (deleteCompanyStatus && deleteCompanyStatus === "success") {
      dispatch(resetDeleteCompany());
      dispatch(changeCompanyModal({ deleteModal: false }));
      history.push("/dashboard/oversikt");
      dispatch(
        setFallbackMessage({
          type: "success",
          content: "Foretaket ble slettet.",
        })
      );
    }
    if (deleteCompanyError) {
      dispatch(resetDeleteCompany());
      dispatch(changeCompanyModal({ deleteModal: false }));
      sendErrorNotification(deleteCompanyError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteCompanyStatus, deleteCompanyError]);

  useEffect(() => {
    if (updateLicenseQuantityError) {
      dispatch(resetUpdateLicenseQuantity());
      sendErrorNotification("Kunne ikke oppdatere brukerlisenser.");
    }

    if (
      updateLicenseQuantityStatus &&
      updateLicenseQuantityStatus === "success"
    ) {
      dispatch(resetUpdateLicenseQuantity());
      sendSuccessNotification("Antall brukerlisenser ble oppdatert.");
      dispatch(retrieveCompanySubscription({ companyId: selectedCompany }));
    }
  }, [updateLicenseQuantityStatus, updateLicenseQuantityError]);

  return (
    <section className="dashboard-company-section">
      <div className="inner-dashboard-company-container">
        <CompanyShowcase
          activeDisplay={activeDisplay}
          setActiveDisplay={setActiveDisplay}
        />
        <CompanyNavigation
          activeDisplay={activeDisplay}
          setActiveDisplay={setActiveDisplay}
        />
        {modal.cancelSubscription && <CancelSubscriptionModal />}
        {modal.addMember && <AddMemberModal />}
        {modal.deleteSpace && <DeleteSpaceModal />}
        {modal.removeMember && <RemoveMemberModal />}
        {modal.changeRole && <ChangeRoleModal />}
        {modal.removePaymentMethod && <RemovePaymentMethodModal />}
        {modal.addPaymentMethod && <AddPaymentMethodModal />}
        {modal.updatePaymentMethod && <UpdatePaymentMethodModal />}
        {modal.changeMainSubscription && <ChangeMainSubscriptionModal />}
      </div>
      <ToastContainer />
    </section>
  );
};

export default withRouter(DashboardCompanyContent);
